"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Alert = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M10.619,4.527 C10.967,3.877 12.032,3.877 12.381,4.527 L12.381,4.527 L19.881,18.527 C20.048,18.84 20.04,19.209 19.857,19.514 C19.675,19.818 19.355,20 19,20 L19,20 L4.001,20 C3.646,20 3.325,19.818 3.143,19.514 C2.96,19.209 2.952,18.84 3.12,18.527 L3.12,18.527 L10.618,4.527 Z M11.5,5 L4.001,19 L19,19 L11.5,5 Z M12,16 L12,17 L11,17 L11,16 L12,16 Z M12,10 L12,15 L11,15 L11,10 L12,10 Z", fillRule: "evenodd" })));
};
Alert.displayName = 'Alert';
exports.default = Alert;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Alert.js.map